import { combineReducers } from "redux";
import LandingPageReducer from "./LandingPageReducer";
import CollectionPageReducer from "./CollectionPageReducer";
import ConfiguratorPageReducer from "./ConfiguratorPageReducer";
import SummaryPageReducer from "./SummaryPageReducer";
import CollectionReducer from "./CollectionReducer";
import RingReducer from "./RingReducer";
import CollectionPageNecklaceReducer from "./CollectionPageNecklaceReducer";
import ConfiguratorPageNecklaceReducer from "./ConfiguratorPageNecklaceReducer";
import NecklaceReducer from "./NecklaceReducer";

export default combineReducers({
  landingPage: LandingPageReducer,
  collectionPage: CollectionPageReducer,
  collectionPageNecklace: CollectionPageNecklaceReducer,
  configuratorPage: ConfiguratorPageReducer,
  configuratorPageNecklace: ConfiguratorPageNecklaceReducer,
  summaryPage: SummaryPageReducer,
  collection: CollectionReducer,
  ring: RingReducer,
  necklace: NecklaceReducer,
});
